export default __webpack_public_path__ + "static/media/libraryFavourite.cde08cdc.png";